module.exports = __webpack_public_path__ + "img/play2_sp@2x.17ae7c5f.png";